<template>
    <div v-if="billingList">
        <h1>{{ billingList.display_name }} - {{ billingList.customer }}</h1>
        <v-data-table
            :headers="headers"
            :items="billingList.lines"
            hide-actions
            class="elevation-1"
            v-bind:pagination.sync="pagination"
            loading="true"
        >
            <template slot="items" slot-scope="props">
              <tr @click="edit(props.item)">
                <td>{{ props.item.article }}</td>
                <td v-bind:class="{ 'font-weight-bold': (props.item.print_attribute ? props.item.print_attribute.includes('F') : false), 'font-italic': (props.item.print_attribute ? props.item.print_attribute.includes('F') : false) }">{{ props.item.name }}</td>
                <td v-if="props.item.editable">{{ props.item.quantity + ' ' + props.item.unit}}</td>
                <td v-else></td>
                <td v-if="props.item.editable">{{ props.item.effective_quantity ? props.item.effective_quantity : 0 }} {{ props.item.unit }}</td>
                <td v-else></td>
              </tr>
            </template>
            <template slot="no-data">
                <p>{{ $vuetify.t('$vuetify.lobis.noResultsForPosition') }}</p>
            </template>
        </v-data-table>
        <v-dialog v-model="dialog" max-width="400px">
          <v-card>
            <v-card-title primary-title>
              {{ editItem.article }} - {{ editItem.name }}
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-flex xs12>
                  <v-text-field v-model="editItem.quantity" label="Menge Auftrag" disabled :suffix="editItem.unit"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field type="number" v-model="editItem.effective_quantity" label="Effektive Menge" :suffix="editItem.unit"></v-text-field>
                </v-flex>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="saveLine">Ok</v-btn>
          </v-card-actions>
          </v-card>
        </v-dialog>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark @click="$router.push({ name: 'BillingList'})">Zurück</v-btn>
    </div>
    <loader :loading="true" v-else></loader>
</template>

<script>
import { BILLINGLIST_SHOW, BILLINGLIST_SAVE } from '../../store/actions/billingList'

export default {
  data () {
    return {
      billingList: null,
      headers: [
        {
          text: 'Artikel',
          align: 'left',
          value: 'article',
          sortable: false
        },
        {
          text: 'Name',
          align: 'left',
          value: 'name',
          sortable: false
        },
        {
          text: 'Menge Auftrag',
          align: 'left',
          value: 'quantity',
          sortable: false
        },
        {
          text: 'Menge gemessen',
          align: 'left',
          value: 'effective_quantity',
          sortable: false
        }
      ],
      pagination: {
        sortBy: 'position',
        descending: false,
        rowsPerPage: 25
      },
      dialog: false,
      editItem: {}
    }
  },
  mounted () {
    this.$store.dispatch(BILLINGLIST_SHOW, (this.$route.params.id)).then((resp) => {
      this.billingList = resp
    })
  },
  methods: {
    edit (item) {
      if (item.editable) {
        this.editItem = item
        this.dialog = true
      }
    },
    close () {
      this.dialog = false
      this.editItem = {}
    },
    save () {
      this.$store.dispatch(BILLINGLIST_SAVE, this.billingList).then(resp => {
        this.$swal({
          type: 'success',
          title: resp.message,
          showConfirmButton: false,
          timer: 1500
        })
        this.$router.push({ name: 'BillingList' })
      }).catch(resp => {
        this.$swal({
          type: 'success',
          title: resp.data.message,
          showConfirmButton: false,
          timer: 1500
        })
      })
    },
    saveLine () {
      this.$store.dispatch(BILLINGLIST_SAVE, this.editItem).then(resp => {
        this.$swal({
          type: 'success',
          title: resp.message,
          showConfirmButton: false,
          timer: 1500
        })
        this.$store.dispatch(BILLINGLIST_SHOW, (this.$route.params.id)).then((resp) => {
          this.billingList = resp
        })
        this.close()
      }).catch(resp => {
        this.$swal({
          type: 'error',
          title: resp.data.message,
          showConfirmButton: false,
          timer: 1500
        })
        this.$store.dispatch(BILLINGLIST_SHOW, (this.$route.params.id)).then((resp) => {
          this.billingList = resp
        })
      })
    },
    send () {
      this.$store.dispatch(BILLINGLIST_SAVE, {send_to_ombis: true, ...this.billingList}).then(resp => {
        this.$swal({
          type: 'success',
          title: resp.message,
          showConfirmButton: false,
          timer: 1500
        })
        this.$router.push({ name: 'BillingList' })
      }).catch(resp => {
        this.$swal({
          type: 'success',
          title: resp.data.message,
          showConfirmButton: false,
          timer: 1500
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BillingList/Show.vue